const CustomIconViewGrid = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="8.421"
      height="8.421"
      rx="2.105"
    />
    <rect
      x="11.58"
      width="8.421"
      height="8.421"
      rx="2.105"
    />
    <rect
      y="11.58"
      width="8.421"
      height="8.421"
      rx="2.105"
    />
    <rect
      x="11.58"
      y="11.58"
      width="8.421"
      height="8.421"
      rx="2.105"
    />
  </svg>
)

export default CustomIconViewGrid
